import React from 'react';
import HeroImage from '../../images/updated.png';
import Logo from '../../images/logo-48.png';
import Logo2x from '../../images/logo-192.png';
import Money from '../../images/icons/Money.svg';
import Approval from '../../images/icons/Approval.svg';
import Trust from '../../images/icons/Trust.svg';
import Hand from '../../images/icons/Hand.svg';
import Experian from '../../images/icons/Experian.svg';
import Call from '../../images/icons/call.svg';
import Mail from '../../images/icons/mail.svg';

import './RegistrationPage.css';
const RegistrationPage = props => {
  const footerItems = [
    {
      logo: {
        src: Money,
        alt: 'Money'
      },
      caption: '1 Application - > 50 + Lenders'
    },
    {
      logo: {
        src: Approval,
        alt: 'Approval'
      },
      caption: 'Instant Approval'
    },
    {
      logo: {
        src: Trust,
        alt: 'Trust'
      },
      caption: 'Trusted by 1,00,000+ Customers'
    },
    {
      logo: {
        src: Hand,
        alt: 'Hand'
      },
      caption: '500 + Cr disbursed'
    },
    {
      logo: {
        src: Experian,
        alt: 'Experian',
        className: 'h-8'
      }
    }
  ];
  return (
    <div className=" relative flex flex-wrap flex-col md:min-h-screen  items-end ">
      <div className="flex-1 w-full flex flex-wrap flex-col md:flex-row h-auto relative overflow-y-hidden mb-8">
        {/* LeftCol */}
        <div className="hidden lg:block w-full lg:w-2/4 pt-24 overflow-y-auto">
          <img className="mx-auto " alt="hero" src={HeroImage} />
          <div className="mx-auto mt-48">
            <p className="font-bold text-center -mt-16 text-lg text-grey-600 ">
              NEED HELP? FOR ANY QUERIES CONTACT US AT
            </p>
            <div className="flex items-baseline justify-center mt-5 px-4 mx-auto ">
              <div className="  inline-flex pt-px phNo">
                <img
                  className="h-4 w-6 mt-2  mr-1"
                  src={Call}
                  alt="Call logo"
                />
                <p className=" text-black-300 text-xl ">080-40828400</p>
              </div>
              <div className="ml-8 inline-flex mail">
                <img className="h-4 w-6 mt-2 mr-1" src={Mail} alt="mail logo" />
                <p className="text-black-300 text-xl">info@fincity.com</p>
              </div>
            </div>
          </div>
        </div>
        {/* RightCol */}
        <div className="flex flex-col w-full mt-5 lg:w-2/4 px-2 md:px-8 lg:pl-0 lg:pr-5 xl:pr-10 justify-center lg:items-start overflow-y-hidden">
          <div
            id="rightCol"
            className=" flex-1 bg-white h-full md:pb-40 pb-20 px-2 pt-2 md:px-4 md:pt-4 w-full text-center overflow-y-hidden"
          >
            <img
              className="block h-16 py-2 mx-auto"
              alt="hero"
              src={Logo}
              srcSet={`${Logo2x} 2x`}
            />
            <div className=" flex-1 py-2 text-black-200">
              Make yourself at home
            </div>
            {props.children}
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="flex-initial flex flex-col md:absolute md:inset-x-0 md:bottom-0 md:flex-row items-center justify-around w-full py-4 px-2 text-sm text-center md:text-left bg-teal">
        {footerItems.map(({ logo, caption }) => (
          <div
            key={logo.src + logo.alt}
            className={`flex flex-row justify-center items-center my-2 md:my-0${
              caption ? ' mx-2' : ' mx-2'
            }`}
          >
            <img
              className={`pr-2${logo.className ? logo.className : ' w-8'}`}
              src={logo.src}
              alt={logo.alt}
            />
            {caption && (
              <p className="text-base md:text-sm text-left text-white">
                {caption}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegistrationPage;
